import { useState } from "react";
import { Check } from "lucide-react";

// Multi-select problems for ONE service visit (one visit fee); duplicates are impossible.
export function ProblemPicker({ service, initial, onDone }) {
    const [sel, setSel] = useState(initial);
    const toggle = (p) => setSel((s) => (s.includes(p) ? s.filter((x) => x !== p) : [...s, p]));
    return (
        <div data-testid="problem-picker">
            <h3 className="font-heading text-lg font-extrabold text-navy">{service.name.replace(" Visit", "")} — what's the issue?</h3>
            <p className="text-xs text-navy/55">Select all that apply — one visit covers them all, the visit fee stays the same.</p>
            <div className="mt-3 max-h-[50vh] space-y-2 overflow-y-auto">
                {service.problems.map((p) => {
                    const on = sel.includes(p);
                    return (
                        <button key={p} type="button" data-testid={`pick-problem-${p.replace(/[^a-z]/gi, "").toLowerCase()}`} onClick={() => toggle(p)}
                            className={`flex w-full items-center justify-between rounded-xl border px-4 py-3 text-left text-sm font-medium transition-colors ${on ? "border-orange bg-orange/5 text-navy" : "border-navy/10 text-navy hover:border-orange"}`}>
                            {p}
                            <span className={`flex h-5 w-5 items-center justify-center rounded-md border-2 ${on ? "border-orange bg-orange text-white" : "border-navy/20"}`}>{on && <Check size={13} />}</span>
                        </button>
                    );
                })}
            </div>
            <button data-testid="problem-picker-done" disabled={!sel.length} onClick={() => onDone(sel)} className="mt-4 w-full rounded-full bg-orange py-3.5 text-sm font-bold text-white disabled:opacity-40">
                {sel.length ? `ADD ${sel.length} PROBLEM${sel.length > 1 ? "S" : ""} · ONE VISIT` : "SELECT A PROBLEM"}
            </button>
        </div>
    );
}
